module.exports = __webpack_public_path__ + "img/water-bottle.a4aca3e1.jpg";